module.exports = __webpack_public_path__ + "img/f2.14405b3a.png";